const modalTitles = [
  'None',
  'Package Restrictions',
  'Terms + Conditions',
  'Promotion Details',
  'Other',
].map(title => ({ id: title, name: title }));

export default modalTitles;
